var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { InputAdornment } from '@mui/material';
import TextField from '../atoms/TextField';
var CurrencyTextField = function (_a) {
    var _b;
    var currency = _a.currency, endAdornment = _a.endAdornment, label = _a.label, onChange = _a.onChange, onKeyDown = _a.onKeyDown, value = _a.value, textFieldProps = __rest(_a, ["currency", "endAdornment", "label", "onChange", "onKeyDown", "value"]);
    var currencySettings = React.useMemo(function () { return currencySettingsFor(currency); }, [currency]);
    var _c = React.useState(currencySettings.filterValue(value)), currentValue = _c[0], setCurrentValue = _c[1];
    React.useEffect(function () {
        setCurrentValue(currencySettings.filterValue(value));
    }, [value, currencySettings]);
    var handleChange = function (ev) {
        var filteredValue = currencySettings.filterValue(ev.target.value);
        if (filteredValue === currentValue) {
            return;
        }
        onChange(filteredValue);
        setCurrentValue(filteredValue);
    };
    return (React.createElement(TextField, __assign({ value: currentValue, onChange: handleChange, onKeyDown: onKeyDown, inputProps: (_b = {}, _b['aria-label'] = label, _b), InputProps: {
            startAdornment: (React.createElement(InputAdornment, { position: "start" }, currencySettings.symbol)),
            endAdornment: endAdornment,
        }, label: label }, textFieldProps)));
};
var currencySettingsFor = function (currency) {
    switch (currency) {
        case 'JPY':
            return { symbol: '￥', filterValue: transformToInteger };
        case 'USD':
            return { symbol: '$', filterValue: transformTo2DigitFloat };
        case 'EUR':
            return { symbol: '€', filterValue: transformTo2DigitFloat };
        case 'KRW':
            return { symbol: '₩', filterValue: transformToInteger };
        case 'TWD':
            return { symbol: 'NT$', filterValue: transformTo2DigitFloat };
    }
};
var transformToInteger = function (value) {
    var result = removeNonNumericCharacters(value);
    result = removeTooManyDigits(result, 0);
    return result;
};
var transformTo2DigitFloat = function (value) {
    var result = removeNonNumericCharacters(value);
    result = removeTooManyDecimalPoints(result);
    result = removeTooManyDigits(result, 2);
    return result;
};
var removeNonNumericCharacters = function (value) {
    return value.replace(/[^0-9.-]/g, '');
};
var removeTooManyDecimalPoints = function (value) {
    var firstDecimalPointIndex = value.indexOf('.');
    return value.replace(/\./g, function (match, offset) {
        return offset > firstDecimalPointIndex ? '' : match;
    });
};
var removeTooManyDigits = function (value, maxDigits) {
    var decimalPointIndex = value.indexOf('.');
    if (decimalPointIndex === -1) {
        return value;
    }
    if (maxDigits > 0) {
        var numberOfDigits = value.length - decimalPointIndex - 1;
        if (numberOfDigits <= maxDigits) {
            return value;
        }
    }
    return parseFloat(value).toFixed(maxDigits);
};
export default CurrencyTextField;
